export const ADVERT = 'Advert'
export const ADVERT_SHOW = 'AdvertShow'
export const ADVERT_CALL = 'AdvertCallV2'
export const OWNER_PROFILE = 'Account.OwnerProfile'
export const CUSTOMER_PROFILE = 'Account.CustomerProfile'
export const HISTORY_ENTRY_OWNER = 'HistoryEntry.OwnerProfile'
export const HISTORY_ENTRY_CUSTOMER = 'HistoryEntry.CustomerProfile'
